import { Page } from "../enums/Page";
import { html, css } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";

const styles: string = css`

    :host {
        font-family: "Onesize";
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto calc(35vh + 10px) minmax(calc(35vh + 10px), 1fr) auto;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        
    }

    .game-style{
        position: absolute;

        background: rgba(0, 0, 0, 0.5); 
        top: 0;
        left: 0;
        height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #settingsDialog {
        background-color: whitesmoke;
        color: black;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -70%);
        width: 300px;
        padding: 25px;
        border-radius: 8px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    }

    h2 {
        margin-top: 0;
    }

    .settings-group {
        margin-bottom: 15px;
        margin-top:20px;
    }

    .settings-group label {
        display: block;
        margin-bottom: 5px;
    }

    .settings-group input {
        width: 100%;
        padding: 8px;
        border-radius: 4px;
        border: 1px solid #ccc;
        margin-left: -3px;
    }

    .button-group {
        display: flex;
        justify-content: space-between;
        margin-top:20px;

    }

    .button-group button {
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        background-color: #4caf50;
        color: white;
        cursor: pointer;
    }

    .button-group button:hover {
        background-color: #4b754d;
    }
`;

export class SettingComponent extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }
        const element: HTMLElement = this.renderSettingsDialog();
        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }
        this.shadowRoot.appendChild(element);
    }

    private renderSettingsDialog(): HTMLElement {
        const element: HTMLElement = html`
            <div class="game-style">
                <style>
                    ${styles}
                </style>

                <div id="settingsDialog">
                    <h2>Game Settings</h2>


                    <div class="settings-group">
                        <label for="language">Language</label>
                        <select id="language" name="language">
                            <option value="english" selected>English</option>
                            <option value="dutch">Dutch</option>
                        </select>
                    </div>

                    <div class="button-group">
                        <button id="applyButton">Apply</button>
                        <button id="closeButton">Close</button>
                    </div>
                </div>
            </div>
        ` as HTMLDialogElement;

        const closeButton: HTMLButtonElement = element.querySelector("#closeButton") as HTMLButtonElement;
        const applyButton: HTMLButtonElement = element.querySelector("#applyButton") as HTMLButtonElement;
        const languageSelector: HTMLSelectElement = element.querySelector("#language")!;
        const savedLanguage: string | null = localStorage.getItem("language");
        if (savedLanguage) {
            languageSelector.value = savedLanguage;
        }

        applyButton.addEventListener("click", async () => {
            const selectedLanguage: string = languageSelector.value;
            localStorage.setItem("language", selectedLanguage);

            if (selectedLanguage === "english") {
                await this.handleLanguageChange("EN");
                console.log("English is selected");
            }
            else if (selectedLanguage === "dutch") {
                await this.handleLanguageChange("NL");

                console.log("Dutch is selected");
            }

            this._gameEventService.switchPage(Page.Canvas);
        });

        closeButton.addEventListener("click", () => {
            this._gameEventService.switchPage(Page.Canvas);
        });

        return element;
    }

    private async handleLanguageChange(language: string): Promise<void> {
        const response: string | undefined = await this._gameRouteService.executeLanguage(language);

        console.log(response);
    }
}
